var map = {
	"./align-text-middle-one.svg": 75842,
	"./application-one-filled.svg": 10686,
	"./attention-filled.svg": 62363,
	"./attention.svg": 28974,
	"./book-one-filled.svg": 94101,
	"./book-one.svg": 75272,
	"./brain-filled.svg": 60373,
	"./brain.svg": 8,
	"./city.svg": 24385,
	"./coordinate-system-filled.svg": 89,
	"./delete.svg": 37253,
	"./delete1.svg": 39118,
	"./elephant.svg": 69179,
	"./exit.svg": 25516,
	"./exit1.svg": 55669,
	"./file-editing-filled.svg": 8198,
	"./file-editing-one-filled.svg": 5135,
	"./filled_home.svg": 91030,
	"./home-filled.svg": 87434,
	"./home-two-filled.svg": 81357,
	"./home-two.svg": 46064,
	"./home.svg": 12777,
	"./icon_line_home.svg": 49030,
	"./idcard.svg": 64721,
	"./iphone.svg": 21511,
	"./love-and-help-filled.svg": 65717,
	"./love-and-help.svg": 65864,
	"./mail-filled.svg": 44498,
	"./mail.svg": 56513,
	"./password.svg": 35943,
	"./peoples.svg": 2468,
	"./permissions.svg": 67696,
	"./personal-privacy-filled.svg": 27496,
	"./personal-privacy.svg": 43799,
	"./personcenter.svg": 18248,
	"./projector-two-filled.svg": 89662,
	"./projector-two.svg": 25029,
	"./set.svg": 65076,
	"./tag.svg": 74548,
	"./task.svg": 37795,
	"./toolkit-filled.svg": 77795,
	"./toolkit.svg": 97862,
	"./userset.svg": 26911
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20527;